import React, { useState } from 'react';
import { Button, Modal, Text } from 'v3/components';
import { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';
import { useFleetManagement } from '../../shared';
import { BodyContainer, FooterContainer } from './styles';

function DeleteRegisterModal() {

  const {
    deleteModal: modalHook,
    selected,
    handleGetData,
    setFleetData
  } = useFleetManagement();

  const [loading, setLoading] = useState(false);
  const snackbar = useSnackbar();

  const handleCancel = () => {
    modalHook.close();
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);

      const payload = {
        fleetRegisterId: selected?.id,
        columnName: 'deletedAt',
        newValue: new Date().toISOString(),
      };

      await cooperplaceApi.put('fleet/management/vehicleManagement', { data: payload });

      setFleetData(old =>
        old.filter(row => row.id !== selected.id)
      );

      snackbar.show(
        <Text>Registro removido com sucesso.</Text>,
        { type: 'success' }
      );

      modalHook.close();

      await handleGetData({ not_loading: true });

    } catch (error) {

      setLoading(false);

      modalHook.close();

      snackbar.show(
        <Text>
          {error?.response?.data?.error
            ? error.response.data.error
            : 'Ocorreu um erro ao tentar deletar o registro'}
        </Text>, {
        type: 'error',
      }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={modalHook.isOpen}
      heading="Deletar registro"
      body={
        <BodyContainer>
          <Text>{`Tem certeza que deseja excluir o registro da placa ${selected?.plate?.plate}?`}</Text>
        </BodyContainer>
      }
      footer={
        <FooterContainer>
          <Button loading={loading} onClick={handleCancel}>
            Cancelar
          </Button>
          <Button loading={loading} onClick={handleConfirm}>
            Excluir
          </Button>
        </FooterContainer>
      }
      handleClose={handleCancel}
    />
  );
}

export default DeleteRegisterModal;
